import PERMISSIONS_LIST from '../../../../../submodules/web-shared/modules/Permissions/permissions-list';
import { portalLevelPermissions } from '../../../../../submodules/web-shared/modules/Permissions/PortalLevelPermissions';

const useAdminAccess = () => {
  const hasPermission = (permission: PERMISSIONS_LIST) => {
    return portalLevelPermissions.isPermissionEnabled(permission, null);
  };

  const hasAdminPageAccess = () => {
    return hasPermission(PERMISSIONS_LIST.admin_page_access);
  };

  const hasManagePowerBiReportsAccess = () => hasAdminPageAccess() && hasPermission(PERMISSIONS_LIST.manage_power_bi_reports);

  return {
    hasAdminPageAccess,
    hasManagePowerBiReportsAccess
  };
};

export default useAdminAccess;